/*
 * @Author: 小周
 * @Date: 2023-09-07 11:52:04
 * @LastEditTime: 2024-06-12 11:06:15
 * @LastEditors: MrZHLF
 * @Description: 获取SAAS token or 用户信息
 */
import request from '@utils/request'

let BASE_URL = process.env.REACT_APP_API_MOBILE
let BASE_URL_INFO = process.env.REACT_APP_API_COMMENT
// 获取token
export function getTokenByLogin(data) {
  return request({
    method: 'post',
    url: `${BASE_URL}/uaa/oauth/token`,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: `${BASE_URL_INFO}/plugins_userc/user/getUserInfoByToken`,
    method: 'get',
  })
}
